<template>
  <div id="pageRoot">
    <p id="text01">Escribe la lista de los lugares a los que saltó Venancio.</p>
    <p id="text02">SALTÓ A...</p>
    <p id="text03">LA</p>
    <p id="text04">LA</p>
    <p id="text05">LA</p>
    <p id="text06">LA</p>
    <p id="text07">EL</p>

    <!-- TEXT ----------------------------------------------------------------------------------------------------->
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="5"
      id="inputField05"
    />
    <!-- TEXT ----------------------------------------------------------------------------------------------------->

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
    <div class="pageSVG">
      <img
        src="/pages/img/sordo/svgPage62.svg"
        class="pageElement"
        style="width: 100%; height: auto"
      />
    </div>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
#inputField01 {
  width: 680px;
  margin-left: 18%;
  margin-top: 20%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField02 {
  width: 680px;
  margin-left: 18%;
  margin-top: 30.5%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField03 {
  width: 280px;
  margin-left: 18%;
  margin-top: 41%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField04 {
  width: 260px;
  margin-left: 59%;
  margin-top: 41%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField05 {
  width: 280px;
  margin-left: 18%;
  margin-top: 51.5%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#text01 {
  /* Escribe la lista de los lugares a los que saltó Venancio. */

  position: absolute;
  left: 8.59%;
  right: 30.76%;
  top: 8.2%;
  bottom: 87.24%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;

  color: #000000;
}

#text02 {
  /* SALTÓ A... */

  position: absolute;
  left: 8.59%;
  right: 73.83%;
  top: 15.62%;
  bottom: 77.99%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 49px;
  /* identical to box height */

  color: #000000;
}

#text03 {
  /* LA */

  position: absolute;
  left: 10.25%;
  right: 84.28%;
  top: 27.86%;
  bottom: 63.67%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 65px;

  color: #2bb673;
}

#text04 {
  /* LA */

  position: absolute;
  left: 10.25%;
  right: 84.28%;
  top: 41.93%;
  bottom: 49.61%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 65px;

  color: #2bb673;
}

#text05 {
  /* LA */

  position: absolute;
  left: 10.25%;
  right: 84.28%;
  top: 55.86%;
  bottom: 35.68%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 65px;

  color: #2bb673;
}
#text06 {
  /* LA */

  position: absolute;
  left: 52.05%;
  right: 42.48%;
  top: 55.86%;
  bottom: 35.68%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 65px;

  color: #2bb673;
}
#text07 {
  /* EL */

  position: absolute;
  left: 10.25%;
  right: 84.67%;
  top: 69.79%;
  bottom: 21.74%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 65px;

  color: #2bb673;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p62/V34.mp4",
        "p62/V35.mp4",
        "p62/V36.mp4",
        "p62/V37.mp4",
        "p62/V39.mp4",
        "p62/V40.mp4",
        "p62/V38.mp4",
      ],
    };
  },
};
</script>